import type { PartnerLogin } from 'src/models/context';
export const parsePartnerLogins = (data: string): PartnerLogin => {
  if (!data) return null;
  const partnerLogins: PartnerLogin[] = JSON.parse(data);
  return partnerLogins[0];
};
